import react from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import Login from "./pages/Login"
import Register from "./pages/Register"
import NotFound from "./pages/NotFound"
import ProtectedRoute from "./components/ProtectedRoute"
import ProfileCheck from "./components/ProfileCheck"
import ChatPrompt from "./pages/ChatPrompt"
import ProfileCreation from "./pages/ProfileCreation"
import Home from "./pages/Home"
import Downloads from "./pages/Downloads"
import AccountSettings from "./pages/AccountSettings"
import Blog from "./pages/Blog"
import BlogPost from "./pages/BlogPost"
import ReportBug from "./pages/ReportBug"
import AddSuggestions from "./pages/AddSuggestions"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import TermsOfService from "./pages/TermsOfService"
import ContactUs from "./pages/ContactUs"
import Career from "./pages/Career"
import OurVision from "./pages/OurVision"
import Donation from "./pages/Donation"
import Subscription from "./pages/Subscription"
import OAuthCallback from "./pages/OAuthCallback"
import { NotificationProvider } from "./contexts/NotificationContext"
import NotificationContainer from "./components/NotificationContainer"
import ScrollToTop from "./components/ScrollToTop"
import { useApiNotifications } from "./hooks/useApiNotifications"
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { RECAPTCHA_SITE_KEY } from "./constants"

function Logout() {
  localStorage.clear()
  return <Navigate to="/login" />
}

function RegisterAndLogout() {
  localStorage.clear()
  return <Register />
}

function AppContent() {
  // Set up API notifications
  useApiNotifications();
  
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/report-bug" element={<ReportBug />} />
        <Route path="/add-suggestions" element={<AddSuggestions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/career" element={<Career />} />
        <Route path="/our-vision" element={<OurVision />} />
        <Route path="/donation" element={<Donation />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route
          path="/chat"
          element={
            <ProtectedRoute>
              <ProfileCheck>
                <ChatPrompt />
              </ProfileCheck>
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-profile"
          element={
            <ProtectedRoute>
              <ProfileCreation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account-settings"
          element={
            <ProtectedRoute>
              <AccountSettings />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/register" element={<RegisterAndLogout />} />
        <Route path="/oauth/callback/:provider" element={<OAuthCallback />} />
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
      <NotificationContainer />
    </BrowserRouter>
  );
}

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </GoogleReCaptchaProvider>
  )
}

export default App